<template>
    <div></div>
</template>
<script>
export default {
    data () {
        return {
            message: {
                'register-card-receive': {
                    success: 'Regular billing has been registered.',
                    failed: 'Failed to register.'
                },
                'cancel-registered-card': {
                    success: 'Regular billing has been canceled.',
                    failed: 'Failed to cancel regular billing.'
                }
            },
            REGISTER_CARD: 'register-card',
            CANCEL_REGISTERED_CARD: 'cancel-registered-card'
        }
    },
    mounted () {
        const replyCd = this.$route.query.replyCd
        const replyMsg = this.$route.query.replyMsg
        const message = (replyCd === '0000') ? this.message[this.$route.name].success : replyMsg
        if (!window.opener) {
            parent.receiveMessage({ replyCd, replyMsg, message })
        } else {
            opener.receiveMessage({ replyCd, replyMsg, message })
            window.close()
        }
    }
}
</script>

<style>

</style>
